import { render, staticRenderFns } from "./Discountinfo.vue?vue&type=template&id=4546e098&scoped=true&lang=html&"
import script from "./Discountinfo.vue?vue&type=script&lang=js&"
export * from "./Discountinfo.vue?vue&type=script&lang=js&"
import style0 from "./Discountinfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Discountinfo.vue?vue&type=style&index=1&id=4546e098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546e098",
  null
  
)

export default component.exports